// Cursor de reconciliación de notificaciones (`latest_id`), compartido por el
// badge y el centro. En sessionStorage: sobrevive recargas de la pestaña pero
// no se mezcla entre usuarios/dispositivos. Monótono: nunca retrocede.
const KEY = 'notificationsLatestId';

export const getLatestId = () => {
  try {
    return Number(sessionStorage.getItem(KEY)) || 0;
  } catch {
    return 0;
  }
};

export const setLatestId = (id) => {
  const value = Number(id) || 0;
  if (value <= getLatestId()) return;
  try {
    sessionStorage.setItem(KEY, String(value));
  } catch {
    /* cuota llena o modo privado: se ignora */
  }
};

export const resetLatestId = () => {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* noop */
  }
};
